// src/pages/NeurologicalTesting.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Widgets from '../components/WidgetTiles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { motion } from 'framer-motion';


const NeurologicalTesting = () => (
    <>
        <Header />
        <div id="content" role="main" className="home">
            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
                <div className="container">
                    <h1>Ketamine Treatment</h1>
                </div>
            </div>

            {/* Content Sections */}
            <div className="container py-5">
                {/* ADHD Testing */}
                <div className="row align-items-center mb-5">
                    <div className="col-md-6">
                        <h2>What is Ketamine?</h2>
                        <p className="text-secondary" style={{ fontSize: 18 }}>
                            Ketamine treatment refers to the use of the medication ketamine, originally developed as an anesthetic, to treat various mental health conditions such as depression, anxiety, obsessive compulsive disorder (OCD), and post-traumatic stress disorder (PTSD). Given at lower doses, ketamine has shown promise in providing rapid relief from symptoms, especially when traditional therapies haven't been effective. Ketamine treatments are completed by our advanced treatments and research team, Revolution Treatments. It's administered under the care of a medical professional, typically through an IV, injections in the muscle, or a nasal spray.
                        </p>
                    </div>
                    <div className="col-md-6">
                        <LazyLoadImage
                            src="/img/ketamine-treatment.jpg"
                            alt="ADHD Testing"
                            className="img-fluid"
                            style={{ borderRadius: "30px" }}
                        />
                    </div>
                </div>
                {/* Services Grid */}
                <div
                    className="w-100"
                    style={{
                        background: 'linear-gradient(90deg, #CDD7E9 0%, rgba(45, 80, 145, 0.92) 22%, rgba(45, 79, 144, 0.93) 79%, #CDD7E9 100%)'
                    }}
                >
                    <div className="container">
                        <h2 className="text-center text-white mb-0">Services</h2>
                    </div>
                </div>
                <div
                    className="w-100"
                    style={{
                        background: 'rgba(138.25, 212.19, 255, 0.20)'
                    }}
                >
                    <div className="container py-5">
                        <div className="row text-center gy-5">
                            {/* IV Ketamine */}
                            <div className="col-12 col-md-4">
                                <LazyLoadImage
                                    src="/img/iv-ketamine.svg"
                                    alt="IV Ketamine Icon"
                                    effect="blur"
                                    className="d-block mx-auto"
                                    style={{ width: 151, height: 151 }}
                                />
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    IV Ketamine
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    IV Ketamine is a cutting edge ketamine treatment that treats depression, anxiety, OCD, PTSD and other mood disorders. Offered in a controlled environment, with trained medical professionals, IV Ketamine delivers effective fast acting relief.
                                </p>
                            </div>

                            {/* IM Ketamine */}
                            <div className="col-12 col-md-4">
                                <LazyLoadImage
                                    src="/img/im-ketamine.svg"
                                    alt="IM Ketamine Icon"
                                    effect="blur"
                                    className="d-block mx-auto"
                                    style={{ width: 151, height: 151 }}
                                />
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    IM Ketamine
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    Our IM Ketamine injections provide a convenient and insurance-covered option for those seeking effective treatment for mental health conditions. Administered by our experienced medical professionals, these injections offer the benefits of ketamine treatment in a tailored and personalized approach.
                                </p>
                            </div>

                            {/* Nasal Spray / Spravato® */}
                            <div className="col-12 col-md-4">
                                <LazyLoadImage
                                    src="/img/nasal-spray.svg"
                                    alt="Nasal Spray Icon"
                                    effect="blur"
                                    className="d-block mx-auto"
                                    style={{ width: 151, height: 151 }}
                                />
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    Nasal Spray/ Spravato<span style={{ fontWeight: 400 }}>®</span>
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    Spravato® is a form of ketamine (esketamine) that is taken as a nasal spray under the supervision of the provider. Offering insurance coverage (with prior authorization) and not requiring a needle injection, Spravato® has unique benefits that make it ideal for many patients.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Ketamine Assisted Therapy Callout */}
                <section
                    className="container my-5"
                    style={{
                        background: 'linear-gradient(180deg, rgba(219,228,238,0.20) 0%, rgba(138,212,255,0.20) 100%)',
                        borderRadius: 8,
                        paddingTop: 11,
                        paddingBottom: 11
                    }}
                >
                    <div className="row justify-content-center">
                        <div className="col-12 d-flex flex-column align-items-center">
                            <h3 className="text-center"> Ketamine Assisted Therapy </h3>
                            <p className="text-center">
                                Ketamine increases neural plasticity, allowing the brain to change in ways that aren’t normally possible
                                for most adults. Combining this effect with therapy sessions can lead to ground-breaking and life-changing
                                results. To learn more, click below to be directed to our advanced treatment site, Revolution Treatments.
                            </p>
                            <a href="https://revolutiontreatments.com/kat" className="button blue">
                                Click Here to Learn More!
                            </a>
                        </div>
                    </div>
                </section>

                {/* Costs & Coverage */}
                <div className="container" style={{ marginTop: '120px' }}>
                    <div className="row d-flex justify-content-between" style={{ margin: '0 -10px' }}>
                        {/* Left */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem' }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #e8f6ff 0%, #8bd4ff 100%)', 
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4 style={{
                                    margin: '15px 0',
                                    fontSize: '1.5rem',
                                    fontWeight: 600,
                                    color: '#2D4F90'
                                }} > Your First Treatment  </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li style={{
                                        margin: '10px 0',
                                        padding: '5px 0',
                                        fontSize: '2.5rem',
                                        background: '#3B67BA',
                                        color: '#FFF'
                                    }}> FREE </li>
                                    <li>
                                        <ul
                                            style={{
                                                listStyleType: 'disc',
                                                listStylePosition: 'inside',
                                                padding: 0,
                                                margin: 0,
                                                textAlign: 'center',
                                            }}
                                        >
                                            <li style={{ padding: '5px 0', color: '#2D4F90' }}>
                                                All patients start by scheduling and completing an intake with one of our trained psychiatric professionals.
                                            </li>
                                            <li style={{ padding: '5px 0', color: '#2D4F90' }}>
                                                If you and your provider decide ketamine is right for you, your first ketamine is always an IV and always probono*, so you can determine if it's right for you without cost barriers.
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Middle */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem' }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #1B2F54 0%, #3B67BA 100%)', 
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    transform: 'scale(1.1)',
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4
                                    style={{
                                        margin: '5px 0',
                                        fontSize: '1.5rem',
                                        fontWeight: 600,
                                        color: '#FFF',
                                        marginBottom: '15px'
                                    }}
                                >
                                    Follow-up Appointments
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li
                                        style={{
                                            fontSize: '2.5rem',
                                            lineHeight: 1,            // make the line-height equal to font-size
                                            background: '#3B67BA',
                                            color: '#FFF',
                                            padding: '20px',
                                        }}
                                    >
                                        $400
                                        <span style={{ fontSize: '1rem', lineHeight: 1.2 }}>
                                            <br />
                                            Or as little as $0 with Insurance!
                                        </span>
                                    </li>
                                    <li>
                                        <ul
                                            style={{
                                                listStyleType: 'disc',
                                                listStylePosition: 'inside',
                                                padding: 0,
                                                margin: 0,
                                                textAlign: 'center',
                                            }}
                                        >
                                            <li style={{ padding: '5px 0', color: '#FFF' }}>Most providers recommend a research supported 6 session treatment series.</li>
                                            <li style={{ padding: '5px 0', color: '#FFF' }}>IV therapy is $400 per treatment after your first, while IM ketamine can range from $0-$250 depending on your insurance.</li>
                                            <li style={{ padding: '5px 0', color: '#FFF' }}>Healthcare Savings Accounts (HSA) are available</li>
                                            <li style={{ padding: '5px 0', color: '#FFF' }}>No interest payment plans available</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Right */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem', }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #e8f6ff 0%, #8bd4ff 100%)', 
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4 style={{
                                    margin: '15px 0',
                                    fontSize: '1.5rem',
                                    fontWeight: 600,
                                    color: '#2D4F90'
                                }} > Community Heroes & <br /> other programs  </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li style={{
                                        margin: '10px 0',
                                        padding: '5px 0',
                                        fontSize: '2.5rem',
                                        background: '#3B67BA',
                                        color: '#FFF'
                                    }}> DISCOUNTED </li>
                                    <li>
                                        <ul style={{
                                            listStyleType: 'disc',
                                            listStylePosition: 'inside',
                                            padding: 0,
                                            margin: 0,
                                            textAlign: 'center',
                                        }}>
                                            <li style={{ padding: '5px 0', color: '#2D4F90' }}>Redemption Psychiatry recognizes the importance of community heroes (first responder, medical professionals, military, and others) and offer discounts to these groups to show our support and do our part to take care of the people that take care of us.</li>
                                            <li style={{ padding: '5px 0', color: '#2D4F90' }}>For more information, ask about our community heroes discounts!</li>
                                            <li style={{ padding: '5px 0', color: '#2D4F90' }}>Redemption is from the community and for the community. For this reason, adjusted pricing is available for those in need!</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Partner Callout */}
                <div
                    className="w-100"
                    style={{ background: '#e8f6ff', marginTop: '80px' }}
                >
                    <div className="container py-5">
                        <div className="row align-items-center">
                            {/* Left: text + buttons */}
                            <div className="col-12 col-md-8">
                                <h2> Learn More About Ketamine at Our Partner Website: </h2>
                                <p> Revolution Treatments is the name of our advanced treatment team, working hard to use modern research to develop the best ketamine, TMS, DBS, and VNS treatments for your benefit. To learn more about all things ketamine, or to explore other revolutionary treatments, click below! Or, if you would like to discuss these treatments with a psychiatric provider, schedule an intake today! </p>
                                <a
                                    href="https://revolutiontreatments.com"
                                    className="button blue"
                                    style={{ marginBottom: '30px', marginRight: '30px' }}
                                >
                                    Revolution Treatments
                                </a>
                                <a href="https://rpsych.com/newpatients" className="button blue" style={{ marginBottom: '30px' }}>
                                    Schedule an Intake
                                </a>
                            </div>

                            {/* Right: partner logo */}
                            <div className="col-12 col-md-4">
                                <LazyLoadImage
                                    src="/img/revolution-logo.svg"
                                    alt="Revolution Treatments Logo"
                                    effect="blur"
                                    className="img-fluid"
                                    style={{
                                        width: '200%',    // twice as wide as the container-based “100%”
                                        maxWidth: 'none', // allow overflow of the parent’s 100% cap
                                        height: 'auto'    // preserve aspect ratio
                                      }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>
);

export default NeurologicalTesting;
